function imageUrl(settings, name) {
    const setting = (settings || []).find((item) => item.name === name);

    return (setting && setting.image && setting.image.url) || null;
}

// Same 1000px split as the main home logo: below it the column sits on the darkened splash image.
function homeSecondaryLogoUrl(settings, windowWidth) {
    const defaultLogo = imageUrl(settings, 'home-secondary-logo');

    if (windowWidth >= 1000) {
        return defaultLogo;
    }

    return imageUrl(settings, 'home-secondary-logo-mobile') || defaultLogo;
}

module.exports = {
    homeSecondaryLogoUrl,
};
